export type { MenuItemsType as MenuItem } from "../StyledSidebarMenu";

export type TFn = (key: string) => string;

export const ICON_SIZE = { width: 25, height: 25 };
